// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Store from './redux/store';
import { Provider } from 'react-redux';

// Check if we have SSR content (from bot redirect) or client-only (from S3)
const rootElement = document.getElementById('root');
const hasSSRContent = rootElement && rootElement.hasChildNodes();

// Use hydrate for SSR content (bots), render for S3 content (normal users)
const renderMethod = hasSSRContent ? ReactDOM.hydrate : ReactDOM.render;

renderMethod(
  <Provider store={Store}>
    <App />
  </Provider>,
  rootElement
);

// Remove the initial data after hydration to prevent memory leaks
if (typeof window !== 'undefined' && window.__INITIAL_DATA__) {
  delete window.__INITIAL_DATA__;
}
